import { iMachineProps } from "./Machine";
import PieChart, { ChartDatum } from "./PieChart";
import {interpolateGreens} from 'd3';



function MachineStatusPieChart(props: {pieChart: iMachineProps[]}) {
    let statusTypeMap = new Map<string, number>()
    for(var i=0;i<props.pieChart.length;i++){
        if(statusTypeMap.has(props.pieChart[i].status)){
            // adding to current value
            var currVal = (statusTypeMap.get(props.pieChart[i].status) || 0) + 1;
            statusTypeMap.set(props.pieChart[i].status, currVal);
        }else{
            // create the value
            statusTypeMap.set(props.pieChart[i].status, 1)
        }

    }
    // list to contain the chart elements
    var data: ChartDatum[] = [];
    statusTypeMap.forEach((count, status)=>{
        var tempChartObj = { label: status, value: count }
        data.push(tempChartObj)
    });

    return PieChart(data, interpolateGreens);

}

export default MachineStatusPieChart;
